import ChevronRight from '@material-ui/icons/ChevronRight';
import PropTypes from 'prop-types';
import React from 'react';

const MenuChevron = () => {
  return (
    <ChevronRight
      style={{
        color: '#d9e1e1',
        fontSize: '35px',
        alignSelf: 'center'
      }}
    />
  );
};

const AdTypeSimpleMenuItem = props => {
  return (
    <div
      className="ad-type-button ad-type-button--no-icon"
      onClick={props.onClick}
      role="presentation"
      data-testid={props.testId}
    >
      <div className="ad-type-button_text">
        <div className="ad-type-button_heading">
          {props.heading}
          {props.isBeta && (
            <img
              className="ad-type-button_beta-icon"
              src="/images/beta.png"
              alt="beta"
            />
          )}
        </div>
      </div>
      <MenuChevron />
    </div>
  );
};

AdTypeSimpleMenuItem.propTypes = {
  isBeta: PropTypes.bool,
  heading: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  testId: PropTypes.string
};

AdTypeSimpleMenuItem.defaultProps = {
  isBeta: false,
  testId: ''
};

export default AdTypeSimpleMenuItem;
